/* Pawply cart rules:
   1) The guide "30 Days to a Happy Dog" is limited to 1 per cart.
   2) 6+ collars in the cart (Buy 3 Get 3) = the guide is added as a FREE gift (Pumper makes it $0).
      Below 6 collars the free-gift guide is taken out again (otherwise it would turn into a paid line).
      (Oct 17 2026: was 3+; Filipe: only the 6-collar offer gets the free guide.)
   3) "Add to cart" on a product page REPLACES what's in the cart (no stacking an old collar on top of a new bundle).
      Adds from inside the cart (drawer upsells) still add on top, and quantities can still be changed in the cart.
   Hooks the form submit itself (not fetch), so other apps that wrap fetch can't skip it. */
(function () {
  if (window.__pwEbookGuard) return;
  window.__pwEbookGuard = true;
  var HANDLE = '30-days-to-a-happy-dog';
  var GUIDE_VARIANT = 57762756231512;
  var COLLARS = { 'the-pawply-collar': 1, 'tricomfort-collar': 1, 'tricomfort-collar-3': 1 };
  var GIFT_AT = 6;
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var _fetch = window.fetch.bind(window);
  var ebookVariants = {};
  ebookVariants[String(GUIDE_VARIANT)] = true;

  function getCart() {
    return _fetch(root + 'cart.js', { headers: { Accept: 'application/json' }, cache: 'no-store' }).then(function (r) { return r.json(); });
  }
  function postJSON(path, body) {
    return _fetch(root + path, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body || {})
    });
  }
  function ss(k, v) {
    try { if (v === undefined) return sessionStorage.getItem(k); if (v === null) sessionStorage.removeItem(k); else sessionStorage.setItem(k, v); } catch (e) { return null; }
  }
  function isGift(i) { return i.properties && Object.prototype.hasOwnProperty.call(i.properties, 'pmpr_gift_product'); }

  // redraw the cart drawer + cart icon without a page reload (cart page: reload)
  function refreshUI() {
    if (/\/cart\/?$/.test(location.pathname)) { location.reload(); return Promise.resolve(); }
    return _fetch(root + '?sections=cart-drawer,cart-icon-bubble', { cache: 'no-store' })
      .then(function (r) { return r.json(); })
      .then(function (s) {
        var p = new DOMParser();
        var drawer = document.querySelector('cart-drawer');
        var dst = document.getElementById('CartDrawer');
        if (drawer && dst && s['cart-drawer']) {
          var src = p.parseFromString(s['cart-drawer'], 'text/html').getElementById('CartDrawer');
          if (src) {
            dst.innerHTML = src.innerHTML;
            var ov = document.getElementById('CartDrawer-Overlay');
            if (ov && drawer.close) ov.addEventListener('click', drawer.close.bind(drawer));
            var srcDrawer = p.parseFromString(s['cart-drawer'], 'text/html').querySelector('cart-drawer');
            if (srcDrawer) drawer.classList.toggle('is-empty', srcDrawer.classList.contains('is-empty'));
          }
        }
        var bubble = document.getElementById('cart-icon-bubble');
        if (bubble && s['cart-icon-bubble']) {
          var b = p.parseFromString(s['cart-icon-bubble'], 'text/html').querySelector('.shopify-section');
          if (b) bubble.innerHTML = b.innerHTML;
        }
        lockInputs();
      })
      .catch(function () { location.reload(); });
  }

  function lockInputs() {
    var inputs = document.querySelectorAll('.quantity__input[data-quantity-variant-id]');
    for (var i = 0; i < inputs.length; i++) {
      var el = inputs[i];
      if (!ebookVariants[el.getAttribute('data-quantity-variant-id')]) continue;
      el.setAttribute('max', '1');
      el.setAttribute('readonly', 'readonly');
      var wrap = el.closest('quantity-input');
      if (wrap && !wrap.classList.contains('pw-qty-locked')) wrap.classList.add('pw-qty-locked');
    }
  }

  // ---------- 1) + 2) guide rules ----------
  var busy = false;
  function enforce() {
    if (busy) return;
    busy = true;
    getCart()
      .then(function (cart) {
        var items = cart.items || [];
        var guides = items.filter(function (i) { return i.handle === HANDLE; });
        guides.forEach(function (i) { ebookVariants[String(i.variant_id)] = true; });
        lockInputs();
        var collars = items.reduce(function (n, i) { return n + (COLLARS[i.handle] ? i.quantity : 0); }, 0);
        var gifts = guides.filter(isGift);
        var paid = guides.filter(function (i) { return !isGift(i); });
        var guideQty = guides.reduce(function (n, i) { return n + i.quantity; }, 0);

        // a) fewer than GIFT_AT collars: take the free-gift guide out (a guide they added themselves stays)
        if (collars < GIFT_AT && gifts.length) {
          var u1 = {};
          gifts.forEach(function (i) { u1[i.key] = 0; });
          return postJSON('cart/update.js', { updates: u1 }).then(function () { return true; });
        }

        // b) GIFT_AT+ collars and no free guide yet: add it (swapping out a paid guide if there is one)
        if (collars >= GIFT_AT && !gifts.length && ss('pwGiftSkip') !== String(collars)) {
          var before = cart.total_price;
          var u2 = {};
          paid.forEach(function (i) { u2[i.key] = 0; });
          var step = paid.length ? postJSON('cart/update.js', { updates: u2 }) : Promise.resolve();
          return step
            .then(function () { return postJSON('cart/add.js', { items: [{ id: GUIDE_VARIANT, quantity: 1, properties: { pmpr_gift_product: '' } }] }); })
            .then(getCart)
            .then(function (after) {
              if (after.total_price <= before) { ss('pwGiftSkip', null); return true; }
              // the gift made the cart MORE expensive (discount didn't apply): undo, don't retry at this quantity
              ss('pwGiftSkip', String(collars));
              var u3 = {};
              (after.items || []).forEach(function (i) { if (i.handle === HANDLE && isGift(i)) u3[i.key] = 0; });
              return postJSON('cart/update.js', { updates: u3 }).then(function () {
                if (!paid.length) return true;
                return postJSON('cart/add.js', { items: paid.map(function (i) { return { id: i.variant_id, quantity: 1, properties: i.properties || {} }; }) }).then(function () { return true; });
              });
            });
        }

        // c) never more than 1 guide: keep the cheapest (free) line
        if (guideQty > 1) {
          guides.sort(function (a, b) { return a.final_price - b.final_price; });
          var u4 = {};
          guides.forEach(function (i, idx) { u4[i.key] = idx === 0 ? 1 : 0; });
          return postJSON('cart/update.js', { updates: u4 }).then(function () { return true; });
        }
        return false;
      })
      .then(function (changed) { if (changed) return refreshUI(); })
      .catch(function () {})
      .then(function () { setTimeout(function () { busy = false; }, 300); });
  }

  // ---------- 3) product-page add replaces the cart ----------
  var resubmitting = false;
  document.addEventListener('submit', function (e) {
    if (resubmitting) return;
    var form = e.target;
    if (!form || !form.getAttribute || !/\/cart\/add/.test(form.getAttribute('action') || '')) return;
    if (form.closest('cart-drawer, #CartDrawer, cart-items, cart-drawer-items, .cart-upsell-container, .cart-upsell')) return;

    // hold this submit, empty the cart, then let the very same submit continue
    e.preventDefault();
    e.stopImmediatePropagation();
    var submitter = e.submitter || form.querySelector('[type="submit"][name="add"], [type="submit"]');
    var before = null;
    ss('pwGiftSkip', null);

    getCart()
      .then(function (cart) {
        before = cart;
        if (cart.items && cart.items.length) return _fetch(root + 'cart/clear.js', { method: 'POST', headers: { Accept: 'application/json' } });
      })
      .catch(function () {})
      .then(function () {
        resubmitting = true;
        try {
          if (form.requestSubmit) form.requestSubmit(submitter && submitter.form === form ? submitter : undefined);
          else form.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
        } finally {
          resubmitting = false;
        }
        // safety net: if the new add failed and left the cart empty, put the previous cart back
        if (before && before.items && before.items.length) {
          setTimeout(function () {
            getCart().then(function (now) {
              if (now.items && now.items.length) return;
              return postJSON('cart/add.js', {
                items: before.items.map(function (i) { return { id: i.variant_id, quantity: i.quantity, properties: i.properties || {} }; })
              }).then(function () { location.reload(); });
            }).catch(function () {});
          }, 4000);
        }
      });
  }, true);

  // ---------- re-check whenever the cart UI changes ----------
  var t1, t2;
  var CART_UI = 'cart-drawer, #CartDrawer, cart-items, cart-drawer-items, #cart-icon-bubble';
  new MutationObserver(function (muts) {
    var hit = false;
    for (var i = 0; i < muts.length && !hit; i++) {
      var n = muts[i].target;
      var el = n.nodeType === 1 ? n : n.parentElement;
      if (el && el.closest && el.closest(CART_UI)) hit = true;
    }
    if (!hit) return;
    clearTimeout(t1); t1 = setTimeout(lockInputs, 50);
    clearTimeout(t2); t2 = setTimeout(enforce, 600);
  }).observe(document.documentElement, { childList: true, subtree: true });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', enforce);
  else enforce();
})();
